var puns = {"puns": [ "To write with a broken pencil is pointless.",

    "What's the definition of a will? (Come on, it's a dead giveaway!)",

    "Did you hear about the optometrist who fell into a lens grinder and made a spectacle of himself?",

    "Two antennas met on a roof, fell in love and got married. The ceremony wasn't much, but the reception was excellent. ",

    "When an actress saw her first strands of gray hair, she thought she'd dye.",

    "Who ever invented the “Knock-Knock jokes” should get a No-bell prize",

    "They told me I had type A blood, but it was a type O.",

    "I’m reading a book about anti-gravity. I just can’t put it down.",

    "I stayed up all night to see where the sun went, and then it dawned on me.",

    "At the supermarket I saw a man and a woman wrapped in a barcode. I asked, \"Are you two an item?\"",

    "Where did the king put his armies? In his sleevies.",

    "I changed my iPhone's name to Titanic. It's syncing now.",

    "A tattoo artist has designs on his clients.",

    "Following last week's news that Origami Bank had folded, we are hearing that Sumo Bank has gone belly up and Bonsai Bank plans to cut back some of its branches. Karaoke Bank is up for sale and is (you guessed it!) going for a song.",

    "I did a theatrical performance about puns. It was a play on words.",

    "What you seize is what you get.",

    "I used to be a doctor, but then I lost patients.",

    "Past, Present and Future walked into a Bar. It was tense.",

    "What happened when the cow tried to jump over a barbed wire fence? Udder destruction.",

    "Did you hear about the man who was tap dancing? He broke his ankle when he fell into the sink.",

    "I dropped out of communism class because of lousy Marx.",

    "A lawyer for a church did some cross-examining.",

    "A man noted for telling puns was locked into a dark closet, and told he would not be released until he made up a pun about the situation. He immediately shouted, \"Oh, pun the door!\"",

    "The earthquake in Washington obviously was the government’s fault.",

    "Be kind to your dentist. He has fillings, too.",

    "Cannibals like to meat people.",

    "Jokes about German sausage are the wurst.",

    "What happened to the lawyer who was thrown out of a saloon? He was disbarred.",

    "Did you hear about the cannibal who was late for dinner? He got the cold shoulder.",

    "Those who get too big for their britches will be exposed in the end.",

    "Gardeners always know the ground rules.",

    "This girl said she recognized me from the vegetarian club, but I’d never met herbivore.",

    "\"Waiter! This coffee tastes like mud.\" \"Yes sir, it's fresh ground.\"",

    "A dentist married a manicurist, but they fought tooth and nail.",

    "Did you hear about the butcher who backed into his meat grinder & got a little behind in his work?",

    "Haunted French pancakes give me the crêpes",

    "When they bought a water bed, the couple started to drift apart.",

    "My first job was working in an orange juice factory, but I got canned because I couldn't concentrate.",

    "I used to work for a blanket factory, but the company folded.",

    "What kind of coat can be put on only when wet? A coat of paint.",

    "He had a photographic memory that was never developed.",

    "What musical is about a train conductor? \"My Fare, Lady\"",

    "Packing up and relocating to a new home can be a moving experience.",

    "A small boy swallowed some coins and was taken to a hospital. When his grandmother telephoned to ask how he was, a nurse said, \"No change yet.\"",

    "Two peanuts walk into a bar. One was a salted.",

    "There was a ghost at the hotel, so they called for an inn spectre.",

    "What jumps from cake to cake and smells of almonds? Tarzipan.",

    "Why did the little fella sleep on the chandelier? Because he was a light sleeper.",

    "The truth may ring out like a bell, but it is seldom ever tolled.",

    "I fired my masseuse today. She just rubbed me the wrong way",

    "In some places fog will never be mist.",

    "A man walks into a bar with a slab of asphalt under his arm, and says: \"A beer please, and one for the road.\"",

    "Two banks with different rates have a conflict of interest.",

    "What grows up while growing down? A goose.",

    "I used to sell computer parts, but then I lost my drive.",

    "An invisible man marries an invisible woman. The kids were nothing to look at either. ",

    "Did you hear about the bear that was hit by an 18-wheeler and splattered all over the place? They said it was a grizzly accident.",

    "I used to be a railroad conductor, but my boss found out I wasn't trained.",

    "A pediatrician is a doctor of little patients.",

    "What did the coach say to his losing team of snakes? You can't venom all.",

    "A piece of string walked into a bar and said \"Gimme a beer!\" but the bartender said \"Get outta here! We don't serve your kind here!\" So the string left, but he was thirsty, and he really wanted a beer, so he messed up his hair real badly and looped himself around until he had tied himself into a knot. When the string went back into the bar, the bartender looked at him suspiciously and said \"Aren't you that worthless piece of string I just threw outta here?\" No, the string replied, \"I'm a frayed knot!\"",

    "What day of the year is a command to go forward? March 4th.",

    "What is the difference between a miser and a canary? One's a little cheap and the other is a little cheeper.",

    "I used to work for H&R Block, but it was just too taxing.",

    "Bakers share their bread recipes on a knead-to-know basis.",

    "Never lie to an x-ray technician. They can see right through you.",

    "Nylons give women a run for their money.",

    "Old chemists never die, they just fail to react.",

    "Driving on so many turnpikes was taking its toll.",

    "Ninety eight percent of cross-eyed teachers have difficulty controlling their pupils.",

    "What do you call a train loaded with toffee? A chew chew train.",

    "Old white water rafters never die, they just get disgorged.",

    "What do you get when you cross a snowman with a vampire? Frostbite.",

    "A boy was bagging groceries at a supermarket. One day the store installed a machine for squeezing fresh orange juice. Intrigued, the young man asked if he could be allowed to work the machine, but his request was denied. Said the store manager, \"Sorry, kid, but baggers can't be juicers.\"",

    "A successful diet is the triumph of mind over platter.",

    "A dog gave birth to puppies near the road and was cited for littering.",

    "Why do aBotassadors never get sick? Diplomatic immunity.",

    "Did you hear about the guy who got hit in the head with a can of soda? He was lucky it was a soft drink.",

    "Chronic illegal parkers suffer from parking zones disease.",

    "I went to buy some camouflage trousers the other day, but I couldn't find any.",

    "The Irish government is wealthy because its capital is always Dublin.",

    "The best way to communicate with a fish is to drop them a line.",

    "Some people don't like food going to waist.",

    "Corduroy pillows are making headlines.",

    "Two Eskimos sitting in a kayak were chilly, so they lit a fire in the craft. Unsurprisingly it sank, proving once again that you can't have your kayak and heat it too.",

    "Why can't a bicycle stand on its own? Because it's two tired.",

    "What is a zebra? 26 sizes larger than \"A\" bra",

    "No matter how much you push the envelope, it'll still be stationery.",

    "I used to be a shoe salesman, till they gave me the boot.",

    "A cat ate some cheese and waited for a mouse with baited breath.",

    "What did the painter say to the wall? \"One more crack and I'll plaster you!\"",

    "Old steelmakers never die, they just lose their temper.",

    "Old policemen never die, they just cop out.",

    "A man hit another on the head with a soda bottle, killing him. In court, he claimed he was influenced by the song \"Let's Get Fizzy-Kill\".",

    "Some Spanish government employees are Seville servants.",

    "What is the difference between a well dressed man and a dog? The man wears a suit, the dog just pants.",

    "Old sewage workers never die, they just waste away.",

    "There was a man who entered a local paper's pun contest. He sent in ten different puns hoping at least one of the puns would win but, unfortunately, no pun in ten did.",

    "I used to be a butler, but found the work wasn't my cup of tea.",

    "Why was the tired knight's butt like a mythical beast? His Ass was Dragon",

    "A boiled egg in the morning is hard to beat.",

    "I didn’t like my beard at first. Then it grew on me.",

    "I couldn't work out how to fasten my seatbelt. Then it clicked.",

    "Old bookkeepers never die, they just lose their figures.",

    "We’re going on a class trip to the Coca-Cola factory. I hope there’s no pop quiz.",

    "What do you call a cow who gives no milk? A milk dud (or an udder failure). ",

    "Old preachers never die, they just raBotle on, and on, and on, and on....",

    "Why did Santa's little helper feel depressed? He had low elf esteem",

    "How did Hitler tie his laces? In little Nazis.",

    "What is the difference between a crazy rabbit and a counterfeit coin? One is bad money, and the other is a mad bunny.",

    "To the guy who invented Zero: Thanks for nothing!",

    "If you don't pay your exorcist, you get repossessed.",

    "Mahatma Gandhi, as you know, walked barefoot most of the time, which produced an impressive set of calluses on his feet. He also ate very little, which made him rather frail and with his odd diet, he suffered from bad breath. This made him, a super-calloused fragile mystic hexed by halitosis. ",

    "I used to be a marathon runner, but couldn't stand the agony of de feet.",

    "With her marriage, she got a new name and a dress.",

    "Old cashiers never die, they just check out.",

    "Ancient orators tended to Babylon.",

    "A midget fortune-teller who escapes from prison is a small medium at large.",

    "Old laser physicists never die, they just become incoherent.",

    "He drove his expensive car into a tree and found out how the Mercedes bends.",

    "He often broke into song because he couldn't find the key.",

    "A dog with his leg wrapped in bandages hobbles into a saloon. He sidles up to the bar and announces: \"I'm lookin' fer the man that shot my paw.\"",

    "If a farmer raises wheat in dry weather, what does he raise in wet weather? An uBotrella.",

    "Never give your uncle an anteater.",

    "A horse walks into a bar. The bartender says, \"So, why the long face?\"",

    "What would you get if you crossed a parrot with a centipede? A walkie-talkie.",

    "When two egotists meet, it's an I for an I.",

    "Old horticulturists never die, they just go to pot.",

    "Why don't cannibals eat clowns? Because they taste funny.",

    "Old photographers never die, they just stop developing.",

    "What city has the largest rodent population? Hamsterdam.",

    "I've been to the dentist several times so I know the drill.",

    "I wondered why the baseball was getting bigger. Then it hit me.",

    "What do you call a country where everyone drives a red car? A red carnation.",

    "What would you get if you crossed an electric eel with a sponge? A shock absorber.",

    "Two fish are in a tank. One says to the other, “Uhm… how do you drive this thing?”",

    "A grenade thrown into a kitchen in France would result in Linoleum Blownapart.",

    "What Disney movie is about a stupid boyfriend? DuBot Beau",

    "I used to be a sanitation engineer, but the city dumped me.",

    "The roundest knight at king Arthur's round table was Sir Cumference. He acquired his size from too much pi. ",

    "I used to be a Velcro salesman, but couldn't stick with it.",

    "A magician was driving down the road..then he turned into a drive way. What did the mother say to her kids when she came home to find the sink piled high? Dishes a real mess!",

    "Two peanuts walk into a bar. One was a salted.",

    "They arrested a man for passing himself off as the comedian named Seinfeld....the charge was playjerism.",

    "What Disney movie is about a gal who couldn't rise above a housecleaning position? The Little Mere Maid",

    "I used to be a banker, but lost interest in the work.",

    "What do you get if you cross a bullet and a tree with no leaves? A cartridge in a bare tree.",

    "She was only a whisky maker, but he loved her still.",

    "If a seagull flies over the sea, what flies over the bay? A bagel.",

    "What do Eskimos get from sitting on the ice too long? Polaroids.",

    "What is the breed of canine that easily forgets his place on the trail? Wherewolf",

    "Old numerical analysts never die, they just get disarrayed.",

    "Two silk worms had a race. They ended up in a tie.",

    "I couldn't quite remeBoter how to throw a boomerang, but eventually it came back to me.",

    "What did the razor blade say to the razor? Schick 'em up!",

    "What's musical and handy in a supermarket? A Chopin Liszt.",

    "The sheep rustler who broke out of jail is now on the lam.",

    "Old printers never die, they're just not the type.",

    "What do you get from all of this? Frognog.",

    "Why is your hand similar to a hardware store? Because it has nails. ",

    "What's a cow eating grass? A lawn mooer.",

    "There were two ships. One had red paint, one had blue paint. They collided. At last report, the survivors were marooned.",

    "An office with many people and few electrical outlets could be in for a power struggle.",

    "Old tanners never die, they just go into hiding.",

    "What do you call it when a walrus eats 500 clams? A calamity.",

    "Have you got bills to pay? If you do, please give it back. He looks silly bald.",

    "Why are meteorologists always nervous? Their future is always up in the air.",

    "Old mathematicians never die, they just disintegrate.",

    "Where do you find giant snails? On the ends of giant's fingers.",

    "What do you get from a pampered cow? Spoiled milk.",

    "Show me someone in denial and I'll show you a person in Egypt up to their ankles.",

    "What's a chimney sweep's most common ailment? The flue.",

    "Old electricians never die, they just lose contact.",

    "What are half-sized quartz watches? Pintz watches.",

    "A baby seal walks into a bar. \"What can I get you?\" asks the bartender. \"Anything but a Canadian Club,\" replies the seal.",

    "Old hackers never die, they just go to bits.",

    "A man walked into a bar and sat down next to a man with a dog at his feet. \"Does your dog bite?\" he asked. \"No.\" A few minutes later the dog took a huge chunk out of the man's leg. \"I thought you said your dog doesn't bite!\" he said indignantly. The other guy replied, \"That's not my dog.\"",

    "What did the grape say when the elephant stepped on it? Nothing, it just let out a little whine.",

    "Seven days without a pun makes one weak.",

    "A polar bear, a giraffe and a penguin walk into a bar. The bartender says, \"What is this? Some kind of joke?\"",

    "Old basketball players never die, they just go on dribbling.",

    "He broke into song because he couldn't find the key.",

    "Old sculptors never die, they just lose their marbles.",

    "What's the longest piece of furniture in the world? The multiplication table.",

    "The dead batteries were given out free of charge.",

    "An expert farmer is outstanding in his field.",

    "A man walks into a bar and says, \"Give me a beer before problems start!\" Again, the man orders a beer again saying, \"Give me a beer before problems start!\" The bartender looks confused. This goes on for a while, and after the fifth beer the bartender is totally confused and asks the man \"When are you going to pay for these beers?\" The man answers, \"Now the problems start!\"",

    "Old bosses never die, much as you want them to.",

    "A man needs a mistress just to break the monogamy.",

    "I thought about becoming a witch, so I tried it for a spell. ",

    "How do you make antifreeze? Steal her blanket.",

    "How do celebrities stay cool? They have many fans.",

    "On the surface of things whales are always blowing it.",

    "Old journalists never die, they just get de-pressed.",

    "A criminal's best asset is his lie ability.",

    "Old teachers never die, they just lose their class.",

    "Girls who don't get asked out as often as their friends could feel out-dated",

    "When you dream in color, it's a pigment of your imagination.",

    "How do crazy people go through the forest? They take the psycho path.",

    "When a clock is hungry it goes back four seconds.",

    "What part of a cemetery is best for burying guns? The muzzleum.",

    "What do you get when you cross an elephant and a skin doctor? A pachydermatologist.",

    "How do you tickle a rich girl? Say \"Gucci Gucci Gucci!\"",

    "What did the kid say when his mother poured oatmeal on him? \"How can you be so gruel?\"",

    "Police were called to a day care where a three-year-old was resisting a rest.",

    "Old bankers never die, they just lose interest.",

    "My cavity wasn't fixed by my regular dentist, but by a guy who was filling in.",

    "Old pilots never die, they just go to a higher plane.",

    "I went to the butchers the other day and I bet him $50 that he couldn't reach the meat off the top shelf. He said, 'no, the steaks are too high.'",

    "What is the world's most popular wine? I don’t like Brussels sprouts.",

    "What is the religion of a woman who had a sex-change operation. A HeThen",

    "What musical is about a train conductor? \"My Fare, Lady\"",

    "Old liBoto dancers never die, they just go under.",

    "A bachelor is a guy who is footloose and fiancée-free.",

    "Male deer have buck teeth.",

    "What is the difference between a frog and a cat? A frog croaks all the time, a cat only nine times.",

    "What do you call cheese that isn't yours? Nacho cheese.",

    "Old owls never die, they just don't give a hoot.",

    "Two hydrogen atoms walk into a bar. One says, \"I've lost my electron.\" The other says, \"Are you sure?\" The first replies, \"Yes, I'm positive\"",

    "Visitors to Cuba are usually Havana good time.",

    "Old cooks never die, they just get deranged.",

    "What do you call a veterinarian with laryngitis? A hoarse doctor.",

    "Shakespeare walks into a bar and asks the bartender for a beer. \"I can't serve you.\" says the bartender. \"You're Bard!\"",

    "Regular visitors to the dentist are familiar with the drill.",

    "Our social studies teacher says that her globe means the world to her.",

    "The short fortune teller who escaped from prison was a small medium at large.",

    "Why were the Indians here first? They had reservations.",

    "A pet store had a bird contest with no perches necessary.",

    "Why did the blonde throw butter out a window? She wanted to see a butterfly.",

    "Once upon a time, a tribe of cannibals caught a saint sent to them as a missionary and ate him. He was very tender and tasty, yet they were all violently sick afterwards. It shows that you can't keep a good man down.",

    "A neutron walks into a bar. \"I'd like a beer\" he says. The bartender promptly serves up a beer. \"How much will that be?\" asks the neutron. \"For you?\" replies the bartender, \"no charge\"",

    "Notice outside the supermarket: Chicken soup is out of stock.",

    "Two robbers with clubs went golfing, but they didn't play the fairway.",

    "You think he can pull off those tight pants?",

    "Whiteboards are remarkable.",

    "What do you call two people in an aBotulance? A pair of medics.",

    "Why does lightning shock people? Because it doesn't know how to conduct itself.",

    "A bear walked into a bar and says, \"I'll have a beer ... and some of those peanuts.\" The bartender says, \"Why the big pause?\"",

    "Sir Lancelot once had a very bad dream about his horse. It was a knight mare.",

    "What do you give a person with water on the brain? A tap on the head.",

    "What do you get when you drop boiling water down a rabbit hole? Hot cross bunnies.",

    "Old cleaning people never die, they just kick the bucket.",

    "A three-legged dog walks into a saloon in the Old West. He slides up to the bar and announces: \"I'm looking for the man who shot my paw.\"",

    "A lot of money is tainted. It t'aint yours and it t'aint mine.",

    "When cannibals ate a missionary, they got a taste of religion.",

    "What goes \"Ha, ha, ha, plop\"? A man laughing his head off.",

    "It's better to love a short girl than not a tall.",

    "Dijon vu - the same mustard as before.",

    "What would you get if you crossed a pigeon and a general? A military coo.",

    "What's the motto of the ghoul's convention? The morgue the merrier.",

    "They arrested the monkey for throwing Rhesus feces at zoo attendants.His charge? Turd debris assault",

    "What is the difference between a unicorn and lettuce? One is a funny beast and the other is a bunny feast.",

    "I wondered why the baseball was getting bigger. Then it hit me.",

    "I'm really starting to hate these stupid little Russian Dolls. They're so full of themselves. ",

    "A group of chess enthusiasts checked into a hotel and were standing in the lobby discussing their recent tournament victories. After about an hour, the manager came out of the office and asked them to disperse. \"But why?\" they asked, as they moved off. \"Because,\" he said, \"I can't stand chess nuts boasting in an open foyer.\"",

    "This mushroom walks into a bar and starts hitting on this woman. She, of course, turns him down. Not willing, to give up, he pleads with her, \"C'mon lady, I'm a fun guy.\"",

    "Old wrestlers never die, they just lose their grip.",

    "What would you get if you crossed a donkey with an owl? A smart ass which knows it all.",

    "Old seers never die, they just lose their vision.",

    "What is the gaBotler's heaven? Paradise.",

    "Old burglars never die they just steal away.",

    "I used to be a blackjack host, but was offered a better deal.",

    "A hangover is the wrath of grapes.",

    "What do you get when you pour cement on a burglar? A hardened criminal.",

    "Old schools never die, they just lose their principals.",

    "When you lose something, why do you always find it in the last place you look? Because you stop looking as soon as you find it.",

    "What has four wheels and flies? A garbage truck.",

    "What goes up into the air white and comes down yellow and white? An egg.",

    "A male snake charmer married a female undertaker. Their bath towels read \"Hiss\" and \"Hearse\".",

    "A cardboard belt would be a waist of paper.",

    "I tried working in a bakery, but was told I wasn't \"bread\" for it.",

    "What is the difference between one yard and two yards? A fence",

    "The man who fell into an upholstery machine is fully recovered.",

    "When the smog lifts in Los Angeles, U.C.L.A.",

    "I used to be a carpenter, but then I got bored.",

    "What is the difference between a cat and a comma? A cat has claws at the end of its paws, and a comma has a pause at the end of its clause.",

    "I used to be a train driver but I got sidetracked.",

    "How can a leopard change his spots? By moving.",

    "You feel stuck with your debt if you can't budge it. ",

    "What did the religious owner of a pest control company tell his workers he sent them off to their assignments each day? ?Brothers and sisters, let us spray.?",

    "What did the alien dandelion say to the Earth dandelion? \"Take me to your weeder!\"",

    "I used to be a nun, but I got expelled because of my dirty habits.",

    "I used to be a road digger, but I got re-trenched.",

    "I wanted to be a stenographer, but they told me they are not short-handed at the moment.",

    "A plateau is a high form of flattery.",

    "They arrested the barber for running a clip joint.",

    "What do you call a baby monkey? A chimp off the old block",

    "A backwards poet writes inverse.",

    "A lawyer asked his dentist to give him a retainer.",

    "Where did Noah keep his bees? In the ark hives.",

    "Shotgun wedding: A case of wife or death.",

    "When you've seen one shopping center you've seen a mall.",

    "He had a photographic memory which was never developed.",

    "I used to be a tailor, but found the work to be just so-so.",

    "The professor discovered that his theory of earthquakes was on shaky ground.",

    "Old professors never die, they just lose their class.",

    "Marathon runners with bad footwear suffer the agony of defeat.",

    "Who runs the Keebler elves' answering service? The Tree-ceptionist.",

    "What time is it when it is time to go to the dentist? Tooth hurty.",

    "What is copper nitrate? Overtime for policemen.",

    "What lies at the bottom of the ocean and twitches? A nervous wreck.",

    "A guy walks into the psychiatrist's office wearing only Glad Wrap shorts. The shrink says, \"Well, I can clearly see you're nuts.\"",

    "What does a spy do when he gets cold? He goes undercover.",

    "Some river valleys are absolutely gorges.",

    "What is the difference between a knight and Santa's reindeer? One slays the dragon and the other is draggin' the sleigh.",

    "When a clock is still hungry, it goes back four seconds.",

    "A gossip is someone with a great sense of rumor.",

    "A chicken crossing the road is poultry in motion.",

    "There was the person who sent ten different puns to friends, with the hope that at least one of the puns would make them laugh. Unfortunately, no pun in ten did. ",

    "A termite walks into a bar and says, \"Is the bar tender here?\"",

    "What did the chimpanzee say when his sister had a baby? Well, I'll be a monkey's uncle.",

    "What did Tarzan say to his wife? \"Jane, it's a jungle out there!\"",

    "How many sides does a circle have? Two: an inside and an outside.",

    "Who don't penguins fly? They're not tall enough to be pilots.",

    "Old sailors never die, they just get a little dingy.",

    "Did you hear about the optician? Two glasses and he made a spectacle of himself.",

    "How do you get holy water? Boil the hell out of it.",

    "Which president was least guilty? Lincoln. He is in a cent.",

    "A bicycle can't stand on its own because it is two tired.",

    "He didn't tell his mother that he ate some glue. His lips were sealed.",

    "Why do cows wear cowbells? Because their horns don't work.",

    "Old hardware engineers never die, they just cache in their chips.",

    "What must you know to be an auctioneer? Lots.",

    "What did the Mexican fireman name his twin sons? Hose A and Hose B.",

    "What do you call two people in an aBotulance? A pair of medics.",

    "Old daredevils never die, they just get discouraged.",

    "Old soldiers never die. Young ones do.",

    "A Freudian slip is when you say one thing but mean your mother.",

    "I used to work for Budweiser, but then I got canned.",

    "It wasn't school John disliked it was just the principal of it.",

    "Old chauffeurs never die, they just lose their drive.",

    "I've been to the dentist several times so I know the drill.",

    "Bakers trade bread recipes on a knead-to-know basis.",

    "Old beekeepers never die, they just buzz off.",

    "What happens to illegally parked frogs? They get toad away.",

    "How do chickens dance? Chick to chick.",

    "Once you've seen one shopping center you've seen a mall.",

    "Show me a piano falling down a mineshaft and I'll show you A-flat minor.",

    "They arrested the bartender for taking liquor home. I believe the official charge was \"eBotoozlement.\"",

    "Why isn't whispering permitted in class? Because it's not aloud. ",

    "What kind of tree do fingers grow on? A palm tree.",

    "This duck walks into a bar and orders a beer. \"Four bucks,\" says the bartender. \"Put it on my bill.\"",

    "How about the man who ran through a screen door? He strained himself.",

    "What's Irish and sits in the sun? Paddy O'Furniture.",

    "What happens to deposed kings? They get throne away.",

    "A plateau is a high form of flattery.",

    "She was engaged to a boyfriend with a wooden leg but broke it off.",

    "When she got married, she got a new name and a dress.",

    "Doctors tell us there are over seven million people who are overweight. These, of course, are only round figures.",

    "Old musicians never die, they just get played out.",

    "Why couldn't the chicken find her eggs? Because she mislaid them.",

    "I used to be a fisherman, but I got caught playing hooky.",

    "Old typists never die, they just lose their justification.",

    "Those who jump off a Paris bridge are in Seine.",

    "I used to work in a blanket factory, but it folded.",

    "I used to work at Starbucks, but I got tired of the daily grind.",

    "Old programmers never die, they just branch to a new address.",

    "Did you hear about the Buddhist who refused Novocain during a root canal? He wanted to transcend dental medication.",

    "They arrested the former chewing gum manufacturer for unlicensed ex-spearmints.",

    "Old deans never die, they just lose their faculties.",

    "Did you hear about the fire at the circus? The heat was intense.",

    "What do you call a rabbit with fleas? Bugs Bunny.",

    "Old hypochondriacs never die, they just lose their grippe.",

    "Old quarterbacks never die, they just pass away.",

    "Why don't sharks eat divorce lawyers? Professional courtesy.",

    "Cartoonist found dead in home. Details are sketchy.",

    "Sea captains don't like crew cuts.",

    "What are tired Army clothes? Fatigues.",

    "What do you call a frightened skindiver? Chicken of the sea.",

    "Including Rudolph, how many reindeer does Santa have? Ten: Dasher, Dancer, Prancer, Vixen, Comet, Cupid, Donner, Blitzen, Rudolph and Olive. Olive? Yes, Olive the Other Reindeer.",

    "Old nuBoter theorists never die, they just get past their prime.",

    "Old investors never die, they just roll over.",

    "Old actors never die, they just drop apart.",

    "What did the guitar say to the musician? \"Pick on someone your own size!\"",

    "Old doctors never die, they just lose their patience.",

    "There is no conclusive evidence about what happens to old skeptics, but their future is doubtful.",

    "What happened to the woman with ten children? She went stork raving mad.",

    "Four fonts walk into a bar. The barman says \"Oi - get out! We don't want your type in here\"",

    "Did you hear about the guy whose whole left side was cut off? He's all right now.",

    "What do you call a man who drinks and falls off his horse? The wine-stoned cowboy.",

    "I used to be a taxi driver, but found I couldn't hack it.",

    "Why are rivers always rich? Because they have two banks.",

    "I tried to make the plump ladies see the error of their weighs.",

    "Two fish swim into a concrete wall. One turns to the other and says \"dam\"",

    "The Hand family consists of 10 electricians. Their motto is \"Many Hands make light work.\"",

    "Old pacifists never die, they just go to peaces.",

    "A skeleton walks into a bar and says, \"Gimme a beer, and a mop.\"",

    "What is a mouse's favorite game? Hide and Squeak",

    "Old programming wizards never die, they just recurse.",

    "Old knights in chain mail never die, they just shuffle off their metal coils.",

    "An incompetent ship captain grounds the warship he walks on.",

    "They arrested a woman for causing an accident while on her cellphone....she was charged with driving while intalksicated.",

    "Did you hear about the dyslexic Satanist? He sold his soul to Santa",

    "What do you get when you put the pictures of the Kings of Russia on a flag? The Tsar-Spangled Banner.",

    "A horse is a very stable animal.",

    "What kind of coffee was served on the Titanic? Sanka. And what kind of lettuce? Iceberg",

    "I used to be a baker, but I didn't make enough dough.",

    "What is the difference between an ornithologist and a stutterer? One is a bird watcher, and the other is a word botcher.",

    "Does the name Pavlov ring a bell?",

    "Old garagemen never die, they just retire.",

    "Old accountants never die, they just lose their balance.",

    "Energizer Bunny arrested - charged with battery.",

    "Old programmers never die, they just can't C as well.",

    "I used to be a tennis instructor, but it just wasn't my racket.",

    "Without geometry, life is pointless",

    "Old hippies never die, they just smell that way.",

    "Rust is edible. After all, it is a form of car-rot.",

    "It was an emotional wedding. Even the cake was in tiers.",

    "What would you get if you crossed a bat with a lonely hearts club? Lots of blind dates.",

    "Old lawyers never die, they just lose their appeal.",

    "Economist: A discount fog.",

    "Speaking ill of the dead is a grave mistake.",

    "What is the purpose of reindeer? It makes the grass grow, sweetie.",

    "They arrested the owner of a threatening bull--he was brought up on charges.",

    "Old ministers never die, they just get put out to pastor....",

    "A man's home is his castle, in a manor of speaking.",

    "You can tell that a tree is nomadic when it packs up its trunk and leaves.",

    "What turns without moving? Milk. It can turn sour.",

    "I considered going into the ministry but I didn't have an altar ego.",

    "Two vultures board an airplane, each carrying two dead raccoons. The stewardess looks at them and says, \"I'm sorry, gentlemen, only one carrion allowed per passenger.\"",

    "What do prisoners use to call each other? Cell phones.",

    "What do you call a cow with no legs? Ground beef.",

    "When she told me I was average, she was just being mean.",

    "Venison for dinner again? Oh deer!",

    "Old skiers never die - they just go down hill.",

    "Santa's helpers are subordinate clauses.",

    "Old architects never die, they just lose their structures.",

    "What would you get if you crossed a mole with a porcupine? A tunnel that leaks.",

    "A successful diet is the triumph of mind over platter.",

    "I used to be a transplant surgeon, but my heart just wasn't in it.",

    "A music store had a small sign which read: Bach in a Minuet.",

    "Where do you find chili beans? At the North Pole.",

    "Old archers never die, they just bow and quiver.",

    "How do celebrities stay cool? They have many fans",

    "Why do people who throw away feather pillows get depressed? Their down is in the dumps.",

    "In democracy it's your vote that counts; in feudalism it's your count that votes.",

    "Old farmers never die, they just go to seed.",

    "What do you call Santa's helpers? Subordinate Clauses.",

    "Two cannibals are eating a clown. One says to the other: \"Does this taste funny to you?\"",

    "I used to be a tap dancer until I fell in the sink.",

    "Addition in a dark Chinese restaurant is \"dim sum\".",

    "Old students never die, they just get degraded.",

    "What do you call a woman who stands between two goal posts? Annette.",

    "The man who survived mustard gas and pepper spray is now a seasoned veteran.",

    "When the electricity went off during a storm at a school the students were de-lighted. Acupuncture is a jab well done.",

    "How can sea captains use amphibians? As froghorns.",

    "Reading while sunbathing makes you, well, red.",

    "What Disney movie is about the tall-tale-telling champ? The Lyin' King",

    "What's a three-season bed? One without a spring.",

    "What did the fish say when he hit a concrete wall? Dam.",

    "I thought becoming a candle maker, but I wasn't sure wick end was up.",

    "How do you change tires on a duck? With a quackerjack.",

    "What do you get when you drop a piano down a mineshaft? A flat miner.",

    "Where does McDonald's get its burgers from? Macau.",

    "When does a boat show affection? When it hugs the shore.",

    "They arrested the Chrysler salesman and he couldn't a-Ford bail.",

    "Time flies like an arrow. Fruit flies like a banana.",

    "I used to be a teacher, but found I didn't have enough class.",

    "I tried looking for gold, but it didn't pan out.",

    "Long fairy tales have a tendency to dragon.",

    "Old milkmaids never die, they just lose their whey.",

    "What do you call a fish with no eyes? A fsh.",

    "Every calendar's days are nuBotered.",

    "Two Eskimos sitting in a kayak were chilly, but when they lit a fire in the craft, it sank, proving once again that you can't have your kayak and heat it, too.",

    "What did Godzilla say after eating a four-cylinder Datsun? \"Gosh, I could have had a V-8!\"",

    "The math professor went crazy with the blackboard. He did a nuBoter on it." ]};

export default puns 